import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
    const token = localStorage.getItem("jwtToken");
    return (
        <>
            {!token ? <Navigate to="/login" replace /> : <Outlet />}
        </>
    );
};

export default ProtectedRoute;